(() => {
  const selectors = [
    '#MainContent > .shopify-section[id*="__section_product_tabs_"]',
    '#MainContent > .shopify-section[id*="__recently_viewed_products_"]',
    '#MainContent > .shopify-section[id*="__product_recommendations_"]',
    '#MainContent > .shopify-section:has(.shopify-app-block)',
  ];

  const reveal = (section) => {
    section.classList.add('sq-deferred-section--rendered');
    section.dispatchEvent(new CustomEvent('sq:deferred-section-rendered', { bubbles: true }));
  };

  const initialize = () => {
    const sections = [...document.querySelectorAll(selectors.join(','))];
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(reveal);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      },
      { rootMargin: '300px 0px' }
    );

    sections.forEach((section) => observer.observe(section));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
